import { apiServerFetchInvite } from '#/api/invite/apiFetchInvite';
import { RouteModule } from '#/horizon/components/RouteModule';
import { setSurrogate } from '#/horizon/middlewares/surrogate.middleware';
import { useI18n } from '#/i18n/hooks/useI18n';
import { authLoginPath } from '#/modules/auth/routing/auth.paths';
import type { RoutePathLoaderArgs } from '#/routing/classes/types/RoutePathLoaderArgs';
import type { RouteProps } from '#/routing/types/RouteProps';

import { AuthLoginPage } from './AuthLogin.page';

export async function loader({
  request,
  url,
  context,
}: RoutePathLoaderArgs<typeof authLoginPath>) {
  const { invite: inviteId } = authLoginPath.searchParamsFromUrl(url);

  if (!inviteId) setSurrogate({ context, data: { type: 'hardcoded-route' } });

  const inviteData = inviteId
    ? await apiServerFetchInvite({ request, context })(inviteId)
    : null;

  return { invite: inviteData ? inviteData.invite : null };
}

export default function AuthLoginRoute({
  loaderData: { invite },
}: RouteProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Log In')}>
      <AuthLoginPage invite={invite} />
    </RouteModule>
  );
}
